<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Domisili Data</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/domisilidata">Domisili Data</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Domisili Data</h4>
                  <p class="card-title-desc mb-0">Memuat nama atau tolok indikator, satuan, dan entitas selain data. Anda juga dapat untuk menampilkan atau tidak pada halaman muka.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Kode</th>
                      <th>Urai Domisili</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in domisilidata" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row" v-text="row.kodedomisili"></td>
                      <td scope="row">
                        <Link :href="`/admin/domisilidata/${row.id}`" v-text="row.uraidomisili"></Link>
                      </td>
                      <td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="domisilidata.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Domisili'" backdrop="static">
    <template #default>
      <form @submit.prevent="action">
        <div class="mb-3">
          <label for="kodedomisili" class="form-label">Kode Domisili</label>
          <input v-model="form.kodedomisili" type="text" class="form-control" id="kodedomisili" />
        </div>
        <div class="mb-3">
          <label for="uraidomisili" class="form-label">Urai Domisili</label>
          <textarea v-model="form.uraidomisili" id="uraidomisili" rows="4" class="form-control"></textarea>
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    domisilidata: Array
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        kodedomisili: '',
        uraidomisili: ''
      },
    }
  },
  methods: {
    edit({ id, kodedomisili, uraidomisili }) {
      this.form.id = id;
      this.form.kodedomisili = kodedomisili;
      this.form.uraidomisili = uraidomisili;
      this.form.show = true;
    },
    action() {
      if(this.form.id) {
        this.$inertia.put('/admin/domisilidata/' + this.form.id, this.form);
      } else {
        this.$inertia.post('/admin/domisilidata', this.form);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.kodedomisili = '';
      this.form.uraidomisili = '';
    },
    remove(row) {
      this.$inertia.delete('/admin/domisilidata/' + row.id);
    }
  },
}
</script>
